var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user" },
    [
      !_vm.selectedCustomField
        ? _c("div", { staticClass: "no user-card" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("SelectCustomField")))])
          ])
        : _vm._e(),
      _vm._v(" "),
      !!_vm.selectedCustomField
        ? _c(
            "div",
            { staticClass: "user-info-container" },
            [
              _c("object-main-info", {
                attrs: {
                  fields: _vm.fields,
                  identifier: _vm.customField ? _vm.customField.label : "",
                  "identifier-label": _vm.$tc("Label", 1),
                  "editing-data": _vm.editingData,
                  "show-edit-button": _vm.actionToExecute !== "addCustomField",
                  "card-label": _vm.cardLabel,
                  height: "100%",
                  "submit-button-label": _vm.submitButtonLabel,
                  "required-fields-filled": _vm.requiredFieldsAreFilled,
                  showEditActionButtons: ""
                },
                on: {
                  "toggle-edit": _vm.toggleEdit,
                  "update-object": _vm.updateCustomField,
                  "save-object": _vm.saveObject,
                  "cancel-edit": function($event) {
                    _vm.discardChangesDialogIsOpen = true
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("loading-spinner", {
        staticStyle: { position: "absolute" },
        attrs: {
          active: _vm.loading,
          "is-full-page": false,
          color: "var(--app-primary-base)"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.saveChangesDialogIsOpen,
          title: _vm.$t("SaveChanges"),
          content: _vm.$t("SaveChangesContent"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-content-save",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.saveObject,
          secondaryAction: function($event) {
            _vm.saveChangesDialogIsOpen = false
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.discardChangesDialogIsOpen,
          title: _vm.$t("DiscardChanges"),
          content: _vm.$t("ClusterCreationConfirmation"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-delete",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.cancelEdit,
          secondaryAction: function($event) {
            _vm.discardChangesDialogIsOpen = false
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.tokenChangesDialogIsOpen,
          title: _vm.$t("RevokeToken"),
          content: _vm.$t("ClusterCreationConfirmation"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-lock",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.revokeToken,
          secondaryAction: _vm.cancelRevokeToken
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f9fbaf2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f9fbaf2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/SystemSettingsManagement/CustomFields/CustomFields.vue
// module id = null
// module chunks = 